import { render } from "./z-task-add-time-modal.vue?vue&type=template&id=2d4f711c"
import script from "./z-task-add-time-modal.vue?vue&type=script&lang=js"
export * from "./z-task-add-time-modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__